const APIS = {
  CATEGORY: `/category/`,
  CUSTOMER: `/customer/`,
  PRODUCT: `/product/`,
  STOCK: `/stock/`,
  ORDER: `/order/`,
  HOLD_ORDER: `/order/hold-order/`,
  CUT_PIECE: `/cut-piece/`,
  SET_PRICE: `/cut-piece/set_price/`,
  SCREEN_CATEGORY: `/screen-category/`,
  ASSIGN_CATEGORY: `/screen-category/assign-category/`,
  REMOVE_CATEGORY: `/screen-category/remove/`,
  ASSIGN_PRODUCT: `/screen-product/assign-product/`,
  REMOVE_PRODUCT: `/screen-product/remove/`,
  SCREEN_PRODUCT: `/screen-product/`,
  COLOR_CATEGORY: `/screen-category/change-color/`,
  COLOR_PRODUCT: `/screen-product/change-color/`,
  PROFILE: `/profile/`,
  RECONCILE: `/purchase/reconcile/`,
  PURCHASE: `/purchase/`,
  ACCOUNT: `/account/`,
  STOCK_HISTORY: `/stock-history/`,
  TRANSACTION: `/transaction/`,
  ADD_CASHOUT: `/transaction/add-cashout/`,
  INVOICE: `/invoice/`,
  TERMS_OF_CONDITIONS: `/invoice/terms-of-conditions/`,
  CUSTOMER_DETAILS: '/invoice-items/'
};
export default APIS;
